export { default as SearchOutlineIcon } from './SearchOutlineIcon';
